module.exports = __webpack_public_path__ + "ProximaNova-Semibold.df8c626.ttf";